import {
  RatingStatisticsResponse,
  RatingSummaryByDayResponse,
  RatingValueResponse,
} from "@/types/service-response";

export default class RatingStatistic {
  private constructor(
      readonly meanValue: number,
      readonly medianValue: number,
      readonly summaryByDay: RatingSummaryByDayResponse[],
      readonly totalOfferReservationRatings: number,
      readonly totalOfferReservations: number,
      readonly valueSummary: RatingValueResponse[],
  ) {}


  static createFromResponse(responseData: RatingStatisticsResponse): RatingStatistic {
    return new RatingStatistic(
      responseData.meanValue,
      responseData.medianValue,
      responseData.summaryByDay,
      responseData.totalOfferReservationRatings,
      responseData.totalOfferReservations,
      responseData.valueSummary
    )
  }
}
